import React from "react";
import { Zap, ChevronRight } from "lucide-react";

const HeroSection = ({ onGetStarted }) => {
  return (
    <section className="relative overflow-hidden flex flex-col justify-center items-center min-h-screen">
      {/* Gradient overlay - base layer */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-white z-0 opacity-80"></div>
      
      {/* Light green grid pattern */}
      <div 
        className="absolute inset-0 z-5 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(134, 239, 172, 0.15) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(134, 239, 172, 0.15) 1px, transparent 1px)
          `,
          backgroundSize: '100px 100px'
        }}
      ></div>
      
      {/* Background image - only visible on tablets and larger screens */}
      <div className="absolute inset-0 z-10 pointer-events-none hidden md:flex md:justify-center md:items-center">
        <img 
          src="/images/HighTrafficKeywords.png" 
          alt="High Ranking Keywords"
          className="max-w-[75%] h-auto object-contain opacity-90"
          loading="lazy"
        />
      </div>
      
      {/* Decorative elements */}
      <div className="absolute right-0 top-1/4 w-60 h-60 md:w-96 md:h-96 bg-green-100 rounded-full filter blur-3xl opacity-30 z-10"></div>
      <div className="absolute left-0 bottom-1/4 w-40 h-40 md:w-64 md:h-64 bg-green-200 rounded-full filter blur-3xl opacity-20 z-10"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-20">
        <div className="text-center max-w-2xl md:max-w-4xl mx-auto">
          

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight">
            Grow Organic Traffic{" "}
            <br />on{" "}
            <span className="text-green-500">
              Auto Pilot
            </span>
          </h1>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8 md:mb-10">
            Get new SEO-optimized articles daily, effortlessly. Outrank competitors while you sleep.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 md:mb-16 w-full">
            <button 
              onClick={onGetStarted}
              className="w-full sm:w-auto flex items-center justify-center px-8 py-3.5 rounded-full text-base font-semibold text-white bg-green-500 hover:bg-green-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
              Start for Free
            </button>
            <button className="w-full sm:w-auto flex items-center justify-center px-8 py-3.5 rounded-full text-base font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow-md">
              See how it works <ChevronRight className="ml-2 h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

